import { render } from "./UpdateIcon.vue?vue&type=template&id=11f671c0&scoped=true"
import script from "./UpdateIcon.vue?vue&type=script&lang=js"
export * from "./UpdateIcon.vue?vue&type=script&lang=js"

import "./UpdateIcon.vue?vue&type=style&index=0&id=11f671c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f671c0"]])

export default __exports__